/* ============================================
   Granatelli FAQ — accordion + category filter
   Scoped to [data-gm-faq] sections
   ============================================ */
(function () {
  'use strict';

  function initFaqSection(root) {
    if (!root || root.dataset.gmFaqReady === '1') return;
    root.dataset.gmFaqReady = '1';

    // ---- Accordion: toggle .is-open + aria-expanded ----
    root.querySelectorAll('.gm-faq__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.gm-faq__item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    // ---- Category tabs: filter visible groups ----
    var tabs = root.querySelectorAll('.gm-faq__tab');
    if (tabs.length === 0) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var active = tab.dataset.faqTab || 'all';

        // Update tab visual state + ARIA
        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        root.dataset.activeCategory = active;

        // Show/hide groups based on data-faq-group match
        root.querySelectorAll('.gm-faq__group').forEach(function (group) {
          var groupKey = group.dataset.faqGroup || '';
          var match = active === 'all' || active === groupKey;
          group.classList.toggle('is-hidden', !match);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gm-faq]').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the Shopify Theme Editor re-renders the section
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-gm-faq]');
    if (section) initFaqSection(section);
  });
})();
